var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"layout"},[_c('div',{staticClass:"layout--header"},[_c('div',{staticClass:"layout--header-title"},[_vm._t("header")],2)]),_c('div',{staticClass:"layout--body"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }